/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneSliderSwiper as ResolvedStandaloneSliderSwiper } from 'base/components/standalone/Slider/Swiper';

export const SliderSwiper: typeof ResolvedStandaloneSliderSwiper = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneSliderSwiper {...props} />
        </ErrorBoundary>
    );
});

export type SliderSwiperProps = PropsFromComponent<typeof SliderSwiper>;

/** @deprecated Use slot architecture instead */
export const SliderSwiperWith = (extras: DynamicStandaloneExtras): typeof SliderSwiper => {
    return function SliderSwiper(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SliderSwiper');
        return <ResolvedStandaloneSliderSwiper {...mergeProps({ options: { theme } }, props)} />;
    }
}